import React, { Component } from 'react';
import { Table, Button } from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import './OrgsPaymentsList.css';
import { sharedLabelsPath } from "../../../reducers/common/localization";
import PaginationOrgs from "../../commonComponents/paginationComponent/PaginationOrgs.container";
import moment from 'moment';
import ChangeBalanceModal from './../changeBalanceModal/ChangeBalanceModal.container';
import { CURRENCIES } from '../../../constants/constants';
import IconContainer from "../../commonComponents/iconContainer/IconContainer";
import {Redirect} from "react-router-dom";
import {LABEL_PATH_BY_ORG_TYPE} from "../../../reducers/organization/organizations";
import {Utils} from "../../../utils/utils";
import Select from "../../commonComponents/customSelect/CustomSelect.container";

class OrgsPaymentList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            editBalanceData: null,
            selectedOrgId: null,
            countryFilter: null
        };
    }

    componentDidMount() {
        this.props.onMount();
    }

    componentWillUnmount() {
        this.props.onSetContinent(null);
    }

    render() {
        if (!_.isNil(this.state.selectedOrgId)) {
            return <Redirect to={'/organization-payments?id=' + this.state.selectedOrgId} push />;
        }

        return (
            <div className='org-payments-list-container'>
                <h4 className="page-label">{_.get(this.props.translation, 'orgs.orgs_payments_list_label')}</h4>
                {this.renderContinentAndCountryFilter()}
                <PaginationOrgs validated countryFilter={this.state.countryFilter}/>
                {this.renderContent()}
                <ChangeBalanceModal data={this.state.editBalanceData} />
            </div>
        )
    }

    renderContent = () => {
        if (this.props.loading) {
            return (
                <div className="org-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="org-status-message-container">
                    <h5>{_.get(this.props.translation, 'orgs.no_data_label')}</h5>
                </div>
            );
        }
        return (
            <Table className='orgs-payments-list-table'>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'orgs.org_label')}</th>
                    <th>{_.get(this.props.translation, 'orgs.org_type_label')}</th>
                    <th>{_.get(this.props.translation, 'orgs.anchor_label')}</th>
                    <th>{_.get(this.props.translation, 'orgs.location_label')}</th>
                    <th>{_.get(this.props.translation, 'finance.paid_till_date_label')}</th>
                    <th className='text-center'>{_.get(this.props.translation, 'finance.balance_label')}</th>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {this.renderOrgsData()}
                </tbody>
            </Table>
        );

    };

    renderContinentAndCountryFilter = () => {
        let continentsOptions = [
            { value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label) },
            ...Utils.getLocationOptions(
                this.props.continents,
                _.get(this.props.translation, sharedLabelsPath.continents)
            )
        ];

        let countriesOptions = [
            { value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label) },
            ...Utils.getLocationOptions(
                this.props.countries,
                _.get(this.props.translation, sharedLabelsPath.countries)
            )
        ];

        return (
            <div className="filters-container">
                <div className="continent-filter-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.continent_label)}</h6>
                    <Select
                        className="continent-filter-select"
                        selectedOption={_.find(continentsOptions, option => option.value === this.props.continentCode || (_.isEmpty(option.value) && _.isEmpty(this.props.continentCode)))}
                        options={continentsOptions}
                        onSelect={this.handleChangeContinentSelect}
                    />
                </div>
                <div className="country-filter-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.country_label)}</h6>
                    <Select
                        className="country-filter-select"
                        selectedOption={_.find(countriesOptions, option => option.value === this.state.countryFilter)}
                        options={countriesOptions}
                        onSelect={this.handleChangeCountrySelect}
                    />
                </div>
            </div>
        )
    };

    handleChangeContinentSelect = (selectedOption) => {
        this.props.onSetContinent(selectedOption.value);
        if (!_.isNil(this.state.countryFilter)) {
            this.setState({countryFilter: null});
            this.props.onChangeCountryFilter(null);
        }
    };

    handleChangeCountrySelect = (selectedOption) => {
        this.setState({countryFilter: selectedOption.value});
        this.props.onChangeCountryFilter(selectedOption.value);
    };

    renderOrgsData = () => {
        return _.map(this.props.data, (orgData, index) => (
            <tr
                className={"orgs-payments-list-row " + (orgData.active ? "" : "not-active")}
                key={index}>
                <td
                    className='org-name-td'
                    data-th={_.get(this.props.translation, 'orgs.org_label') + ":"}
                    onClick={this.handleTableRowClick(orgData.id)}>
                    {orgData.orgName}
                </td>
                <td
                    className='org-type-td'
                    data-th={_.get(this.props.translation, 'orgs.org_type_label') + ":"}
                    onClick={this.handleTableRowClick(orgData.id)}>
                    {_.get(this.props.translation, sharedLabelsPath[LABEL_PATH_BY_ORG_TYPE[orgData.orgType]])}
                </td>
                <td
                    className='anchor-td'
                    data-th={_.get(this.props.translation, 'orgs.anchor_label') + ":"}
                    onClick={this.handleTableRowClick(orgData.id)}>
                    <div>{orgData.anchorName + '\n'}</div>
                    <a onClick={this.handleMailtoLinkClick} href={"mailto:" + orgData.anchorEmail}>{orgData.anchorEmail}</a>
                </td>
                <td
                    className='location-td'
                    data-th={_.get(this.props.translation, 'orgs.location_label') + ":"}
                    onClick={this.handleTableRowClick(orgData.id)}>
                    {_.get(this.props.translation, 'countries.' + orgData.location)}
                </td>
                <td
                    className={'paid-till-date-td' + (!moment(orgData.paidTillDate).isSameOrAfter(moment().startOf('day')) ? ' invalid' : '')}
                    data-th={_.get(this.props.translation, 'finance.paid_till_date_label') + ":"}
                    onClick={this.handleTableRowClick(orgData.id)}>
                    {!_.isNil(orgData.paidTillDate) ? moment(orgData.paidTillDate).format("L") : ""}
                </td>
                <td className='balance-td' data-th={_.get(this.props.translation, 'finance.balance_label') + ":"}>
                    <div>
                        {orgData.balance.amount + CURRENCIES[orgData.balance.currency]}
                    </div>
                    <div>
                        <Button className="btn-sm" color="link" onClick={this.onChangeBalanceClick(orgData)}>
                            {_.get(this.props.translation, 'finance.change_label')}
                        </Button>
                    </div>
                </td>
                <td className='orgs-payments-list-create-icon-td' onClick={this.handleTableRowClick(orgData.id)}>
                    <IconContainer
                        key={index}
                        icon='create'
                        className='orgs-payments-list-create-icon'
                        title={_.get(this.props.translation, sharedLabelsPath.edit_button)}
                    />
                </td>
            </tr>
        ));
    };

    onChangeBalanceClick = (data) => () => {
        this.setState({
            editBalanceData: {
                id: data.id,
                balance: data.balance.amount,
                balanceCurrency: data.balance.currency
            }
        });

        this.props.onChangeBalance();
    };

    handleTableRowClick = (orgId) => () => {
        this.setState({ selectedOrgId: orgId });
    };
}

OrgsPaymentList.propTypes = {
    translation: PropTypes.object.isRequired,
    data: PropTypes.array,
    loading: PropTypes.bool,
    onMount: PropTypes.func.isRequired,
    onChangeBalance: PropTypes.func.isRequired,
    onSetContinent: PropTypes.func.isRequired,
    onChangeCountryFilter: PropTypes.func.isRequired,
};

export default OrgsPaymentList;



// WEBPACK FOOTER //
// ./src/components/organizationManagement/orgsPaymentsList/OrgsPaymentsList.js